import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Flex, Tab, TabList, Tabs } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

const tabStyles = {
    base: {
        color: "#444444",
        _hover: { bg: "#dd8d8d", color: "#ffffff" },
        _selected: { bg: "#a32b29", color: "#ffffff" },
    },
};

function AdminDashboard() {
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);

    const tabPaths = ["faq", "files", "contacts", "distro", "apps-manager", "roles", "messages", "config"];

    useEffect(() => {
        const currentIndex = tabPaths.findIndex(path => location.pathname.endsWith(path));
        setTabIndex(currentIndex !== -1 ? currentIndex : 0);
    }, [location]);

    return (
        <Box p={4} bg="#f4f0f0" sx={{
            height: '100vh',
            overflow: 'hidden'
        }}>
            <Tabs index={tabIndex} onChange={(index) => setTabIndex(index)} variant="soft-rounded">
                <TabList>
                    <Tab as={NavLink} to="faq" {...tabStyles.base}>FAQ</Tab>
                    <Tab as={NavLink} to="files" {...tabStyles.base}>Files</Tab>
                    <Tab as={NavLink} to="contacts" {...tabStyles.base}>Contacts</Tab>
                    <Tab as={NavLink} to="distro" {...tabStyles.base}>Distro</Tab>
                    <Tab as={NavLink} to="apps-manager" {...tabStyles.base}>Apps Manager</Tab>
                    <Tab as={NavLink} to="roles" {...tabStyles.base}>User Roles</Tab>
                    <Tab as={NavLink} to="messages" {...tabStyles.base}>Messages</Tab>
                    <Tab as={NavLink} to="config" {...tabStyles.base}>Config</Tab>
                </TabList>
            </Tabs>
            <Flex bg="#ffffff" sx={{ height: 'calc(100vh - 80px)' }} mt={4} p={4} borderRadius="md" boxShadow="md">
                <Outlet />
            </Flex>
        </Box>
    );
}

export default AdminDashboard;
